import React, { FC } from 'react'

import { QuestionModal, Text } from '../../components'
import { useStyle } from './decline-offer-modal.styles'

import { DeclineOfferModalProps } from './decline-offer-modal.types'

export const DeclineOfferModal: FC<DeclineOfferModalProps> = ({
  open,
  description,
  descriptionTx,
  onClose,
  onSubmit
}) => {
  const classes = useStyle()

  if (!open) {
    return <></>
  }

  return (
    <QuestionModal
      classNameContainer={classes.container}
      className={classes.modal}
      title="Decline Offer"
      titleTx="declineOffer.modal.title"
      successText="Decline"
      successTx="declineOffer.modal.success"
      cancelText="Back"
      cancelTx="declineOffer.modal.cancel"
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <Text
        className={classes.title}
        color="darkBlue"
        preset="h4"
        text="Are you sure?"
        tx="declineOrder.modal.secondaryTitle"
      />
      <Text
        className={classes.description}
        color="inactive"
        preset="body"
        text={description}
        tx={descriptionTx}
      />
    </QuestionModal>
  )
}
